const bindings = new WeakMap();

function destroySection(sectionEl) {
  const binding = bindings.get(sectionEl);
  if (!binding) return;
  binding.controller.abort();
  cancelAnimationFrame(binding.frame);
  clearTimeout(binding.timer);
  bindings.delete(sectionEl);
}

function initializeSection(configEl) {
  const sectionEl = configEl.closest('.shopify-section');
  if (!sectionEl) return;
  destroySection(sectionEl);
  const config = JSON.parse(configEl.textContent);
  const sid = config.sectionId;
  const variantIds = new Set((config.variantIds || []).map(String));
  const binding = { controller: new AbortController(), frame: null, timer: null };
  const signal = binding.controller.signal;
  bindings.set(sectionEl, binding);

  function bindPopup(){
    var openBtn = document.getElementById('sb-open-' + sid);
    var overlay = document.getElementById('sb-ing-' + sid);
    if (!openBtn || !overlay) return;
    var dialog = overlay.querySelector('[role="dialog"]');
    var closeBtn = overlay.querySelector('.sb-close');
    var lastFocused = null;
    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    if (dialog && !dialog.hasAttribute('tabindex')) {
      dialog.setAttribute('tabindex', '-1');
    }

    function getFocusable() {
      return Array.prototype.slice.call(overlay.querySelectorAll(focusableSelector)).filter(function(el) {
        return el.offsetParent !== null;
      });
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) {
        e.preventDefault();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openOverlay(){
      lastFocused = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden','false');
      openBtn.setAttribute('aria-expanded','true');
      requestAnimationFrame(function() {
        var focusable = getFocusable();
        if (focusable.length) {
          focusable[0].focus();
        } else if (dialog) {
          dialog.focus();
        }
      });
    }
    function closeOverlay(){
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden','true');
      openBtn.setAttribute('aria-expanded','false');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      } else {
        openBtn.focus();
      }
    }

    openBtn.addEventListener('click', openOverlay, { signal: signal });
    if (closeBtn) closeBtn.addEventListener('click', closeOverlay, { signal: signal });
    overlay.addEventListener('click', function(e){ if (e.target === overlay) closeOverlay(); }, { signal: signal });
    overlay.addEventListener('keydown', function(e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeOverlay();
      } else {
        trapFocus(e);
      }
    }, { signal: signal });
  }


  bindPopup();
  if (!config.overridesOn) return;
  const variantImageMap = config.variantImageMap;

  function cards() {
    return sectionEl.querySelectorAll('.image-link-blocks__item[data-sb-v-key]');
  }
  function swapCardImages(variantId) {
    var map = variantImageMap[variantId] || {};
    cards().forEach(function(card){
      var key = card.getAttribute('data-sb-v-key');
      if (!key) return;
      var url = map[key];

      var img = card.querySelector('img');
      if (!img) return;

      if (!img.dataset.origSrc) {
        img.dataset.origSrc    = img.getAttribute('src') || '';
        img.dataset.origSrcset = img.getAttribute('srcset') || '';
        img.dataset.origSizes  = img.getAttribute('sizes') || '';
      }
      if (url) {
        img.setAttribute('src', url);
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      } else {
        if (img.dataset.origSrc) {
          img.setAttribute('src', img.dataset.origSrc);
          if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
          if (img.dataset.origSizes)  img.setAttribute('sizes',  img.dataset.origSizes);
        }
      }
    });
  }

  /* ---------- Ingredients swap helpers (uses your <template> blocks) ---------- */
  function tpl(id){ var t=document.getElementById(id); return t ? t.innerHTML : ''; }
  function setIngredientsHtml(html){
    var box = document.getElementById('sb-ing-content-' + sid);
    if (box) box.innerHTML = html || '';
  }
  function swapIngredients(variantId){
    var html = tpl('sb-ing-variant-' + sid + '-' + variantId);
    if (html && html.trim().length) setIngredientsHtml(html);
    else setIngredientsHtml(tpl('sb-ing-default-' + sid));
  }

  /* ---------- Determine current/initial variant ---------- */
  function currentVariantIdFromForm() {
    var el = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="id"]'))
      .find(function(input){ return variantIds.has(String(input.value)); });
    return el ? String(el.value) : null;
  }
  function getInitialVariantId() {
    var idFromForm = currentVariantIdFromForm();
    if (idFromForm) return idFromForm;

    var idFromLiquid = config.initialVariantId;
    if (idFromLiquid && idFromLiquid !== '') return idFromLiquid;

    try {
      var jsonScript = document.querySelector('script[type="application/json"][data-product-id="' + config.productId + '"]');
      if (jsonScript) {
        var data = JSON.parse(jsonScript.textContent);
        if (data && data.selected_or_first_available_variant && data.selected_or_first_available_variant.id)
          return String(data.selected_or_first_available_variant.id);
        if (data && data.variants && data.variants.length)
          return String(data.variants[0].id);
      }
    } catch(e) {}
    return null;
  }

  function applyForVariant(vid) {
    if (!vid || !variantIds.has(String(vid))) return;
    swapCardImages(vid);
    swapIngredients(vid);
  }

  /* ---------- React to variant changes ---------- */
  function onVariantEvent(e) {
    var v = e && e.detail && (e.detail.variant || e.detail.selectedVariant || e.detail.productVariant);
    var form = e.target && (e.target.form || (e.target.closest && e.target.closest('form')));
    var input = form && form.querySelector('[name="id"]');
    var vid = v && v.id ? String(v.id) : (input ? String(input.value) : null);
    applyForVariant(vid);
  }
  document.addEventListener('variant:change', onVariantEvent, { signal: signal });
  document.addEventListener('variant:changed', onVariantEvent, { signal: signal });
  document.addEventListener('product:variant-change', onVariantEvent, { signal: signal });
  document.addEventListener('theme:product:variant:change', onVariantEvent, { signal: signal });

  document.addEventListener('change', function(ev){
    if (ev.target && ev.target.name === 'id') applyForVariant(String(ev.target.value));
  }, { signal: signal });

  /* ---------- Force initial apply ---------- */
  function forceInitialApply() {
    var vid = getInitialVariantId();
    applyForVariant(vid);
    binding.frame = requestAnimationFrame(function(){ applyForVariant(getInitialVariantId()); });
    binding.timer = setTimeout(function(){ applyForVariant(getInitialVariantId()); }, 300);
  }

  forceInitialApply();
}

function initializeSections(root) {
  root.querySelectorAll('[data-image-link-blocks-config]').forEach(initializeSection);
}

initializeSections(document);
document.addEventListener('shopify:section:load', function(event) {
  initializeSections(event.target);
});
document.addEventListener('shopify:section:unload', function(event) {
  destroySection(event.target);
});
